import { render } from "./InventoryRecordsTab.vue?vue&type=template&id=3267ddf1"
import script from "./InventoryRecordsTab.vue?vue&type=script&lang=js"
export * from "./InventoryRecordsTab.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__